import * as React from 'react';
import "ag-grid-community/dist/styles/ag-theme-balham.css";
import "ag-grid-community/dist/styles/ag-theme-balham-dark.css"
import {helpHeaderTemplate} from "../../common/AgHeaderHelpToolTip";
import AgGridFooter from "../../common/AgGridFooter";
import Axios from "../../../../config/Axios";
import toastr from "toastr";
import AgSelectAllHeader from "../../common/AgSelectAllHeader";
import Utils from "../../../../Utils";
import CreateFunctionalityModal from "./components/createUserModal/CreateFunctionalityModal";
import {
    createNewFunctionality,
    deleteFunctionality,
    editFunctionality,
    getAllEndpoints,
} from "../../../../actions/boCoreActions";
import AgGridUtils from "../../../../AgGridUtils";
import AgGridHelpToolTip from "../../common/AgGridFilterHelpTooltip";
import TextAreaModal from "../../../common/TextAreaModal/TextAreaModal";
import './functionalitiesGrid.css'
import AccessControlModal, {Access, GridType} from "../../../common/AccessControlModal/AccessControlModal";
import history from "../../../../config/history";
import {Routes} from "../../../../config/routes";
import AssignedEndpointsAndRoutes from "./components/uiRotesAndEndpointsModal/AssignedEndpointsAndRoutes";
import _ from "lodash";
import {AttributeTypeEnum} from "../../enums/AttributeTypeEnum";

const AgGridReact = require('ag-grid-react').AgGridReact;

interface State {
    columnDefs: any;
    rowData: any;
    gridApi: any;
    columnApi: any;
    selectedFunctionality: any;
    modalData: any;
    loading: boolean;
    showModal: boolean;
    role: string;
    textAreaModalParams: any;
    showRoleInfoModal: boolean;
    gridType: GridType;
    access: Access;
    modalFuncInfo: any;
    modalBtnText: string;
    showUIRoutesModal: boolean,
    apiEndpointsModal: any
    uiRoutesModal: any
}

interface Props {
    renderInModal?: boolean,
    userId?: number,
    groupId?: number,
    access?: Access,
}

class FunctionalitiesGrid extends React.Component<Props, State> {
    textAreaModalRef: any;
    historyFilter: boolean = false;
    constructor(props) {
        super(props);
        this.state = {
            columnDefs: [],
            rowData: [],
            gridApi: null,
            columnApi: null,
            loading: false,
            showModal: false,
            selectedFunctionality: null,
            role: '',
            showRoleInfoModal: false,
            textAreaModalParams: null,
            modalData: {
                uiRoutes: [],
                apiEndpoints: [],
                usedNames: []
            },
            gridType: null,
            access: null,
            modalFuncInfo: null,
            modalBtnText: 'Manage Functionalities',
            showUIRoutesModal: false,
            apiEndpointsModal: null,
            uiRoutesModal: null,
        };
        this.textAreaModalRef = React.createRef();
    }

    componentDidMount() {
        this.buildGrid();
        $(this.refs.quickFilterBox).focus();
        document.addEventListener('keydown', this.keydownHandlerFunctionalities);
    }

    componentWillUnmount(): void {
        document.removeEventListener('keydown', this.keydownHandlerFunctionalities);
    }

    keydownHandlerFunctionalities = (e) => {
        if (e.shiftKey && e.keyCode === 40) {
            e.preventDefault();
            Utils.$('.ag-floating-filter-input')[0].focus();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 78) {
            Utils.$('#new-func-btn').click();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 69) {
            Utils.$('#edit-btn').click();
        }
        if (e.ctrlKey && e.altKey && e.keyCode === 68) {
            Utils.$('#delete-btn').click();
        }
        if (e.keyCode === 9) {
            e.preventDefault();
            const element = document.activeElement;
            const id = element.id.split('-')[3];

            if (element.classList.contains("ag-floating-filter-input")) {
                if (Utils.$('.ag-floating-filter-input').length - 1 === Number.parseInt(id)) {
                    this.setGridFistCellOnFocus(e);
                } else {
                    const index = Number.parseInt(id) + 1;
                    Utils.$('.ag-floating-filter-input')[index].focus();
                }
            }
        }
    };

    setGridFistCellOnFocus = (event) => {
        if (event.keyCode === 9) {
            event.preventDefault();

            // scrolls to the first row
            this.state.gridApi.ensureIndexVisible(0);

            // scrolls to the current column
            let currentCol = this.state.columnApi.getAllDisplayedColumns()[0];
            this.state.gridApi.ensureColumnVisible(currentCol);

            // sets focus into the grid cell
            this.state.gridApi.setFocusedCell(0, currentCol);
        }
    };

    buildGrid = () => {
        const columnDefs = [
            {
                id: "",
                headerName: "ID",
                field: "id",
                headerTooltip: "id",
                type: 'text',
                width: 120,
                checkboxSelection: true,
                suppressSizeToFit: true,
                headerComponent: AgSelectAllHeader,
                dataType: AttributeTypeEnum.INT,
            },
            {
                field: 'functionalityName',
                headerName: "Functionality Name",
                tooltipField: 'Functionality Name',
                headerTooltip: "Functionality Name",
                type: 'text',
                cellRenderer: (params) => {
                    return params.value;
                }
            },
            {
                field: 'description',
                headerName: "Description",
                tooltipField: 'Description',
                headerTooltip: 'Description',
                cellRenderer: this.cellRendererForTextArea,
            },
            {
                field: 'apiEndpoints',
                headerName: "API Endpoints",
                tooltipField: 'API Endpoints',
                headerTooltip: "API Endpoints",
                cellRenderer: this.endpointsCellRenderer
            },
            {
                field: 'uiRoutes',
                headerName: "UI Routes",
                tooltipField: 'UI Routes',
                headerTooltip: 'UI Routes',
                cellRenderer: this.uiRoutesCellRenderer
            },
            {
                field: 'allowedRoles',
                headerName: "Allowed Roles",
                tooltipField: 'Allowed Roles',
                headerTooltip: "Allowed Roles",
                type: 'text',
                cellRenderer: (params) => {
                    return params.data.allowedRoles.map(item =>item.roleName).join(', ')
                }
            },
            {
                field: 'deniedRoles',
                headerName: "Denied Roles",
                tooltipField: 'Denied Roles',
                headerTooltip: "Denied Roles",
                cellRenderer: (params) => {
                    return params.data.deniedRoles.map(item =>item.roleName).join(', ')
                }
            },
            {
                field: 'usersGroupsAccess',
                headerName: "Users & Groups Access",
                tooltipField: 'Users & Groups Access',
                headerTooltip: "Users & Groups Access",
                sortable: false,
                filter: false,
                floatingFilter: false,
                width: 180,
                minWidth: 180,
                type: 'text',
                hide: this.props.renderInModal,
                lockVisible:  this.props.renderInModal,
                cellRenderer: (params: any) => {
                    const eDiv = document.createElement('div');
                    eDiv.innerHTML = `<button title="Users - Allowed Access" id="show-allowed-users" class="show-allowed-btn">U</button>
                                       <button title="Users - Denied Access" id="show-denied-users" class="show-denied-btn" style="margin-left: 8px">U</button>
                                        <button title="Groups - Allowed Access" id="show-allowed-groups" class="show-allowed-btn" style="margin-left: 8px">G</button>
                                       <button title="Groups - Denied Access" id="show-denied-groups" class="show-denied-btn" style="margin-left: 8px">G</button>`

                    const eButtonUsersAllowed = eDiv.querySelectorAll('#show-allowed-users')[0];
                    const eButtonUsersDenied= eDiv.querySelectorAll('#show-denied-users')[0];
                    const eButtonGroupsAllowed = eDiv.querySelectorAll('#show-allowed-groups')[0];
                    const eButtonGroupsDenied= eDiv.querySelectorAll('#show-denied-groups')[0];
                    eDiv.style.cssText = 'display: flex; white-space: initial; width: 100%; justify-content: center; padding: 3px 0 3px 0';

                    eButtonUsersAllowed.addEventListener('click', (event) => {
                        event.stopImmediatePropagation();
                        Utils.blurTheActiveElements();
                        this.setFuncModalProps(GridType.USERS, Access.ALLOWED, {id: params.data.id, name: params.data.functionalityName});
                    });

                    eButtonUsersDenied.addEventListener('click', (event) => {
                        event.stopImmediatePropagation();
                        Utils.blurTheActiveElements();
                        this.setFuncModalProps(GridType.USERS, Access.DENIED, {id: params.data.id, name: params.data.functionalityName});
                    });
                    eButtonGroupsAllowed.addEventListener('click', (event) => {
                        event.stopImmediatePropagation();
                        Utils.blurTheActiveElements();
                        this.setFuncModalProps(GridType.GROUPS, Access.ALLOWED, {id: params.data.id, name: params.data.functionalityName});
                    });

                    eButtonGroupsDenied.addEventListener('click', (event) => {
                        event.stopImmediatePropagation();
                        Utils.blurTheActiveElements();
                        this.setFuncModalProps(GridType.GROUPS, Access.DENIED, {id: params.data.id, name: params.data.functionalityName});
                    });

                    return eDiv;
                }
            },
        ]
        this.setState({
            columnDefs: columnDefs
        }, () => this.addFilterIndex())
    }

    addFilterIndex = () => {
        Utils.$(".ag-floating-filter-input").each(function (index) {
            Utils.$(this).attr('id', 'funcs-search-filter-' + index);
            Utils.$(this).attr('index', (index + 2));
        });
    };

    endpointsCellRenderer = (params: any) => {
        if (params.data.apiEndpoints.length <= 2) {
            let str = ''
            params.data.apiEndpoints.forEach(item => {
                str += `${item.method} ${item.url}` + '<br/>'
            })
            return `<div class="cell-text-wrap">${str}</div>`
        } else if (params.data.apiEndpoints.length > 2) {
            const eDiv = document.createElement('div');
            eDiv.innerHTML = `<button title="Show All Api Endpoints" id="show-api-endpoints" class="grid-button-dark">Show All (${params.data.apiEndpoints.length})</button>`;
            const eButton = eDiv.querySelectorAll('#show-api-endpoints')[0];
            eDiv.style.cssText = 'display: flex; white-space: initial; width: 100%';

            eButton.addEventListener('click', (event) => {
                event.stopImmediatePropagation();
                Utils.blurTheActiveElements();
                this.setState({
                    apiEndpointsModal: params
                }, () => this.showAssignedEndpointsAndRoutes())
            });

            return eDiv;
        }
    }

    uiRoutesCellRenderer = (params: any) => {
        if (params.data.uiRoutes.length <= 2) {
            let str = ''
            params.data.uiRoutes.forEach(item => {
                str += `${item}` + '<br/>'
            })
            return `<div class="cell-text-wrap">${str}</div>`
        } else if (params.data.uiRoutes.length > 2) {
            const eDiv = document.createElement('div');
            eDiv.innerHTML = `<button title="Show All UI Routes" id="show-api-endpoints" class="grid-button-dark">Show All (${params.data.uiRoutes.length})</button>`;
            const eButton = eDiv.querySelectorAll('#show-api-endpoints')[0];
            eDiv.style.cssText = 'display: flex; white-space: initial; width: 100%';

            eButton.addEventListener('click', (event) => {
                event.stopImmediatePropagation();
                Utils.blurTheActiveElements();
                this.setState({
                    uiRoutesModal: params
                }, () => this.showAssignedEndpointsAndRoutes())
            });

            return eDiv;
        }
    }

    setFuncModalProps = (gridType: GridType, access: Access, modalFuncInfo: any) => {
        this.setState({
            gridType,
            access,
            modalFuncInfo,
        }, () => this.showAccessControlModal())
    }

    cellRendererForTextArea = (params: any) => {
        const eDiv = document.createElement('div');
        eDiv.innerHTML = `<span style="max-width: calc(100% - 40px); word-wrap: break-word; white-space: nowrap; text-overflow: ellipsis; overflow: hidden">${params.value}</span>
                            <span><button id="previewTxtBtn" style="float: right; background-color: transparent; border: transparent;">
                                <i class="fas fa-search fa-lg"></i></button></span>`;
        const eButton = eDiv.querySelectorAll('#previewTxtBtn')[0];
        eDiv.style.cssText = 'display: flex; white-space: initial; justify-content: space-between; width: 100%';

        eButton.addEventListener('click', (event) => {
            event.stopImmediatePropagation();
            this.showTextArea(event, params);
        });

        return eDiv;
    }

    showTextArea = (event: any, params: any) => {
        this.setState({
            textAreaModalParams: params,
        }, () => this.textAreaModalRef.current.open())
    }

    restoreEventListener = () => {
        document.addEventListener('keydown', this.keydownHandlerFunctionalities);
        $(this.refs.quickFilterBox).focus();
    }

    ServerSideDatasource() {
        return {
            getRows: (params: any) => {
                const limit = params.request.endRow - params.request.startRow;
                const page = (params.request.endRow / limit) - 1;
                const sortObj = AgGridUtils.generateSortData(params.request.sortModel);
                const sortKeys = Object.keys(sortObj);
                let sort = sortKeys.length > 0 ? `&sort=${sortKeys[0] + ';' + sortObj[sortKeys[0]]}` : '';
                let filter = AgGridUtils.generateFilterDataV2(params);
                let apiPath = `functionality/all?size=${limit}&page=${page}${sort}&${filter}`;

                if (this.props.renderInModal && this.props.userId) {
                    apiPath = `functionality/user/${this.props.userId}/all?allowed=${this.props.access === Access.ALLOWED}&size=${limit}&page=${page}${sort}&${filter}`
                } else if (this.props.renderInModal && this.props.groupId) {
                    apiPath = `functionality/group/${this.props.groupId}/all?allowed=${this.props.access === Access.ALLOWED}&size=${limit}&page=${page}${sort}&${filter}`
                }

                Axios.instanceV2.get(apiPath)
                    .then((response: any) => {
                        const gridData = response.data.data.map(item => {
                            return {
                                id: item.id,
                                functionalityName: item.functionalityName,
                                apiEndpoints: item.apiEndpoints,
                                uiRoutes: item.uiRoutes,
                                roles: item.roles,
                                description: item.description,
                                allowedRoles: item.allowedRoles,
                                deniedRoles: item.deniedRoles,
                            }
                        });

                        if (gridData.length === 0) {
                            this.state.gridApi.showNoRowsOverlay()
                        }
                        try {
                            const lastRow = gridData.length < limit ? params.request.startRow + gridData.length : -1;
                            params.successCallback(gridData, lastRow);
                            this.state.gridApi.gridOptionsWrapper.gridOptions.selectAllHeader.update(response.data.totalElements,
                                (limit * (page + 1)) > response.data.totalElements ?
                                    response.data.totalElements : (limit * (page + 1)),
                                params.parentNode.gridApi.getSelectedRows().length);
                            if (this.state.gridApi.gridOptionsWrapper.gridOptions.selectAllHeader.isSelected()) {
                                this.state.gridApi.gridOptionsWrapper.gridOptions.selectAllHeader.selectAll();
                            }
                            this.state.gridApi.sizeColumnsToFit();
                            this.forceUpdate();
                        } catch (e) {
                            console.error(e);
                        }

                    })
                    .catch((e) => {
                        AgGridUtils.serverSideErrorHandler(e)
                        params.failCallback();
                    })
                    .finally(() => {
                        if (this.historyFilter) {
                            this.state.gridApi.forEachNode(node => node.rowIndex ? 0 : node.setSelected(true))
                            this.historyFilter = false;
                        }
                    })
            }
        }
    }

    onGridReady = (params) => {
        if (!this.state.gridApi && !this.state.columnApi) {
            this.setState({
                gridApi: params.api,
                columnApi: params.columnApi
            }, () => {
                params.api.sizeColumnsToFit();
                $("#hide-nav-btn").on("click", function () {
                    setTimeout(() => {
                        params.api.sizeColumnsToFit();
                    }, 500);
                });
            })
        }
        params.api.setServerSideDatasource(this.ServerSideDatasource());
    }

    onGridReadyFirstRender = (params) => {
        this.setState({
            gridApi: params.api,
            columnApi: params.columnApi
        }, () => {
            this.setFilterFromHistory();
            params.api.sizeColumnsToFit();
            $("#hide-nav-btn").on("click", function () {
                setTimeout(() => {
                    params.api.sizeColumnsToFit();
                }, 500);
            });
        })
    }

    setFilterFromHistory = () => {
        // @ts-ignore
        if (history.location.state && history.location.state.id) {
            this.historyFilter = true;
            this.state.gridApi.setFilterModel({
                id: {
                    filterType: "text",
                    type: "contains",
                    //@ts-ignore
                    filter: `=="${history.location.state.id}"`
                }
            })
            history.replace({
                ...history.location,
                state: undefined
            })
        }
    }

    getModalData = async () => {
        const [endpoints] = await Promise.all([
            getAllEndpoints()
        ]);

        if (endpoints && endpoints.data) {
            const endpointsDropDown = endpoints.data.map(api => {
                return {
                    id: api.id,
                    value: api.id,
                    label: `${api.method} ${api.url}`,
                }
            })

            const rowData = [];
            this.state.gridApi.forEachNode(node => rowData.push(node.data.functionalityName));

            return {
                showModal: true,
                modalData: {
                    ...this.state.modalData,
                    uiRoutes: this.getRoutesAsDropDownOptions(),
                    apiEndpoints: endpointsDropDown,
                    usedNames: rowData
                }
            }
        }
        return null;
    }

    getRoutesAsDropDownOptions = () => {
        let routes = Object.keys(Routes);
        // the removed ui routes from the list are only visible for MTA
        // and some of them for Sys Admin
        routes = routes.filter(route =>
            Routes[route] !== Routes.BUSINESS_OBJECTS &&
            Routes[route] !== Routes.DATA_VIEW_CONFIG &&
            Routes[route] !== Routes.TENANT_MANAGEMENT &&
            Routes[route] !== Routes.USER_MANAGEMENT);
        return routes.map(route => {
            return {
                label: Routes[route],
                value: Routes[route],
            }
        });
    }

    createFunctionality = (dto: any) => {
        createNewFunctionality(dto)
            .then(() => {
                this.state.gridApi.onFilterChanged();
            })
            .finally(() => {
                this.hideModal()
            })
    }

    editFunctionalityHandler = async (funcId: number, dto: any) => {
        const {selectedFunctionality} = this.state;
        let hasChanges = false;
        const requests = [];

        if (dto.apiEndpoints.add.length !== 0 || dto.apiEndpoints.remove.length !== 0) {
            hasChanges = true;
        }
        if (dto.description !== selectedFunctionality.description ||
            dto.name !== selectedFunctionality.functionalityName) {
            hasChanges = true;
        }
        if (_.isEqual([...dto.uiRoutes].sort(), [...selectedFunctionality.uiRoutes].sort()) === false) {
            hasChanges = true;
        }

        if (hasChanges) {
            requests.push(editFunctionality(funcId, dto));
            try {
                const [response] = await Promise.all(requests);
                if (response) {
                    this.state.gridApi.onFilterChanged();
                    this.hideModal();
                    return response
                }
            } catch (e) {
                this.hideModal();
            }
        } else {
            toastr.warning('There are no changes')
        }
    }

    onRowSelected = (params) => {
        setTimeout(() => {
            this.state.gridApi.gridOptionsWrapper.gridOptions.selectAllHeader.onRowSelected(params);
            this.forceUpdate();
            if (this.props.renderInModal) {
                this.setState({
                    modalBtnText: this.state.gridApi.getSelectedRows().length > 0 ? 'Edit Functionality' : 'Manage Functionalities'
                })
            }
        }, 0)
    }

    onNewHandler = () => {
        this.getModalData().then(response => {
            if (response) {
                Utils.blurTheActiveElements();
                this.setState({
                    showModal: response.showModal,
                    modalData: response.modalData,
                    selectedFunctionality: null
                })
            }
        })
        document.removeEventListener('keydown', this.keydownHandlerFunctionalities);
    }

    onEditHandler = () => {
        const selected = this.state.gridApi.getSelectedRows();
        if (selected.length === 0) {
            toastr.warning("Please select one functionality");
            return;
        }
        this.getModalData().then(response => {
            if (response) {
                Utils.blurTheActiveElements();
                this.setState({
                    showModal: response.showModal,
                    modalData: response.modalData,
                    selectedFunctionality: selected[0]
                })
            }
        })
        document.removeEventListener('keydown', this.keydownHandlerFunctionalities);
    }

    onDeleteHandler = () => {
        const selectedRows = this.state.gridApi.getSelectedRows()
        if (selectedRows.length > 0) {
            Utils.blurTheActiveElements();
            Utils.$.confirm({
                title: 'Confirm?',
                keyboardEnabled: true,
                escapeKey: 'cancel',
                backgroundDismiss: false,
                theme: 'dark',
                typeAnimated: false,
                content: `You are about to delete 1 functionality, this procedure is irreversible.`,
                type: 'red',
                buttons: {
                    ok: {
                        text: "Yes!",
                        btnClass: 'btn-danger',
                        keys: ['enter'],
                        action: () => {
                            const deleteRequests = []
                            selectedRows.forEach((functionality: any) => {
                                deleteRequests.push(deleteFunctionality(functionality.id));
                            });
                            this.deleteFunctionalities(deleteRequests);
                        }
                    },
                    cancel: () => {
                    }
                }
            });
        } else {
            toastr.warning("Please select one functionality");
        }
    }

    deleteFunctionalities = async (deleteRequests: any) => {
        try {
            const [response] = await Promise.all(deleteRequests);
            if (response) {
                this.state.gridApi.onFilterChanged();
            }
        } catch (e) {
            console.log(e);
        }
    }

    hideModal = () => {
        this.setState({
            selectedFunctionality: null,
            showModal: false
        })
    }

    showAccessControlModal = () => {
        this.setState({
            showRoleInfoModal: true
        })
    }

    hideAccessControlModal = () => {
        this.setState({
            showRoleInfoModal: false,
            access: null,
            gridType: null,
            modalFuncInfo: null
        })
    }

    showFuncsPage = () => {
        if (this.state.gridApi.getSelectedRows().length > 0) {
            history.push({
                pathname: `${process.env.ENV_PREFIX}/functionalities`,
                state: {
                    id: this.state.gridApi.getSelectedRows()[0].id
                }
            });
        } else {
            history.push(`${process.env.ENV_PREFIX}/functionalities`)
        }
    }

    showAssignedEndpointsAndRoutes = () => {
        this.setState({
            showUIRoutesModal: true
        })
    }

    hideAssignedEndpointsAndRoutes = () => {
        this.setState({
            showUIRoutesModal: false,
            apiEndpointsModal: null,
            uiRoutesModal: null
        })
    }

    render() {
        return (
            <div style={{height: 'calc(100% - 75px)'}} className={'access-control-grid'}>
                {this.props.renderInModal === true ? null :
                <header style={{height: 50, display: "flex", justifyContent: "space-between", alignItems: 'center'}} className="bo-core-header top-header">
                    <div style={{paddingLeft: 4, width: "100%"}}>
                        <span id="functionalitiesSearchTitle" style={{paddingTop: 3}} className="header-title">Functionalities</span>
                        <div className="control-buttons">
                            <button onClick={this.onNewHandler} style={{marginRight: 2, height: 36}}
                                    className="btn btn-new-design"
                                    id={'new-func-btn'} title={'CTRL + ALT + N'}>
                                <i className="fas fa-plus"/> <strong style={{fontSize: '13px'}}
                                                                     className={'shortcut-btn-letters'}>N</strong>ew
                            </button>
                            <button onClick={this.onEditHandler} style={{marginRight: 2, height: 36}}
                                    className="btn btn-new-design"
                                    id={'edit-btn'} title={'CTRL + ALT + E'}>
                                <i className="fas fa-edit"/> <strong style={{fontSize: '13px'}}
                                                                     className={'shortcut-btn-letters'}>E</strong>dit
                            </button>
                            <button onClick={this.onDeleteHandler} style={{height: 36}}
                                    id={'delete-btn'}
                                    title={'CTRL + ALT + D'}
                                    className="btn btn-danger">
                                <i className="fas fa-trash-alt"/> <strong style={{fontSize: '13px'}}
                                                                          className={'shortcut-btn-letters'}>D</strong>elete
                            </button>
                        </div>
                    </div>
                </header>}
                <div id={this.props.renderInModal === true ? 'modal-functionalities-grid' : 'functionalities-grid'}>
                    <div style={{height: '100%'}}>
                        {this.props.renderInModal === true ?
                            <header className={'instance-layout-grid-header'} style={{height: 40}}>
                                <h5>Functionalities</h5>
                                <button onClick={this.showFuncsPage}
                                        style={{height: 33, marginTop: 3, marginRight: 3}}
                                        className="btn new-style-btn">{this.state.modalBtnText}</button>
                            </header> : null}
                        <div style={{width: "100%", height: "100%"}}
                             className={"ag-theme-balham-dark ag-grids"}>
                            <AgGridReact
                                onGridReady={this.onGridReady}
                                onFirstDataRendered={this.onGridReadyFirstRender}
                                columnDefs={this.state.columnDefs}
                                rowData={this.state.rowData}
                                onRowSelected={this.onRowSelected}
                                onFilterChanged={() => AgGridUtils.deselectAllRows(this.state.gridApi)}
                                defaultColDef={{
                                    minWidth: 150,
                                    flex: 1,
                                    filter: "agTextColumnFilter",
                                    floatingFilter: true,
                                    sortable: true,
                                    tooltipComponent: AgGridHelpToolTip,
                                    filterParams: {
                                        filterOptions: ['contains'],
                                        applyButton: true,
                                        clearButton: true,
                                        suppressAndOrCondition: true
                                    },
                                    floatingFilterComponentParams: {suppressFilterButton: true},
                                    headerComponentParams: {
                                        template: helpHeaderTemplate
                                    },
                                    autoHeight: true,
                                    resizable: true,
                                }}
                                gridOptions={{
                                    suppressDragLeaveHidesColumns: true,
                                    floatingFilter: true,
                                    rowSelection: "single",
                                    rowModelType: 'serverSide',
                                    suppressCellSelection: true,
                                    blockLoadDebounceMillis: 300
                                }}
                            >
                            </AgGridReact>
                            <AgGridFooter
                                totalCount={this.state.gridApi ? this.state.gridApi.gridOptionsWrapper.gridOptions.
                                selectAllHeader.getState().totalItemsCount : 0}
                                loadedCount={this.state.gridApi ? this.state.gridApi.gridOptionsWrapper.gridOptions.
                                selectAllHeader.getState().loadedItemsCount : 0}
                                selectedCount={this.state.gridApi ? this.state.gridApi.gridOptionsWrapper.gridOptions.selectAllHeader.getState().selectedItemsCount : 0}
                            />
                    </div>
                </div>
                    <CreateFunctionalityModal createFunctionality={this.createFunctionality}
                                              restoreEventListener={this.restoreEventListener}
                                              editFunctionality={this.editFunctionalityHandler}
                                              hideModal={this.hideModal}
                                              showModal={this.state.showModal}
                                              modalData={this.state.modalData}
                                              selectedFunctionality={this.state.selectedFunctionality}/>

                    <AccessControlModal modalTitle={`${this.state.gridType} With ${this.state.access} Access To ${this.state.modalFuncInfo?.name}`}
                                        showModal={this.state.showRoleInfoModal}
                                        gridType={this.state.gridType}
                                        access={this.state.access}
                                        modalFuncInfo={this.state.modalFuncInfo}
                                        closeModal={this.hideAccessControlModal}
                    />
                    <TextAreaModal readOnly={true}
                                   gridParams={this.state.textAreaModalParams}
                                   modalRef={this.textAreaModalRef}
                    />
                    <AssignedEndpointsAndRoutes showModal={this.state.showUIRoutesModal}
                                                hideModal={this.hideAssignedEndpointsAndRoutes}
                                                apiEndPoints={this.state.apiEndpointsModal}
                                                uiRoutes={this.state.uiRoutesModal}
                    />
                </div>
            </div>
        );
    }
}

export default FunctionalitiesGrid



// WEBPACK FOOTER //
// ./app/components/bo-core/grids/FunctionalitiesGrid/FunctionalitiesGrid.tsx